import { render, staticRenderFns } from "./AffiliateCard.vue?vue&type=template&id=6f4de7f5"
import script from "./AffiliateCard.vue?vue&type=script&lang=ts"
export * from "./AffiliateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports